import { combineReducers } from '@reduxjs/toolkit';

import testCasesReducer from '@polyai/stream/store/reducers/testing/slices/test-cases';

import {
  createTestCase,
  deleteTestCase,
  setTestCaseAssertions,
  setTestCaseFunctionCalls,
  setTestCaseTags,
  updateTestCase,
} from './actions';
import type { TestCase, TestingState } from './types';

export { testCaseAdapter, testCaseSelectors } from './slices/test-cases';

export const TestingSliceReducers = {
  testCases: testCasesReducer,
};

const testingReducer = combineReducers(TestingSliceReducers);

export {
  createTestCase,
  updateTestCase,
  deleteTestCase,
  setTestCaseAssertions,
  setTestCaseFunctionCalls,
  setTestCaseTags,
};

export type { TestCase, TestingState };

export default testingReducer;
